/* ======================================================================== */
/* 34. Preloader */
/* ======================================================================== */
function Preloader() {

	var tl = new TimelineMax();

	return new Promise(function (resolve) {

		tl
			.add(function () {
				setTimeout(function () {
					window.$pageWrapper.removeClass('page-wrapper_hidden');
				}, 100);
			})
			.add(function () {
				resolve(true);
			});


	});

}
